import { createStyles } from '@/styles/theme/utils';

export const viewCardStyles = createStyles({
   client_data_area: {
      bg: 'black',
      py: '16',
      '@media (max-width: 767px)': {
         py: '10',
      },
   },
   container: {
      px: '12',
      '@media (max-width: 767px)': {
         px: '6',
      },
   },
   card_area: {
      // bg: 'url(/assets/images/noise_bg.png) no-repeat top left',
      bg: '#231f20',
      p: '30px',
      borderRadius: '20px',
   },
   carousel_arrow_area: {
      w: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      '& button': {
         padding: 0,
         h: '30px',
         w: '30px',
         minW: '0',
         borderRadius: '50%',
         background: '#013C58',
         color: 'white',
         '&:hover': {
            background: 'white',
            color: '#013C58',
         },
         '&:first-of-type': {
            position: 'absolute',
            left: '-100px',
         },
         '&:last-of-type': {
            position: 'absolute',
            right: '-100px',
         },
      },
   },
});
